import { render } from "./evaluationDetail.vue?vue&type=template&id=154f826d&scoped=true"
import script from "./evaluationDetail.vue?vue&type=script&lang=js"
export * from "./evaluationDetail.vue?vue&type=script&lang=js"

import "./evaluationDetail.vue?vue&type=style&index=0&id=154f826d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154f826d"]])

export default __exports__